import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ShieldCheck,
    User,
    Image as ImageIcon,
    Camera,
    Upload,
    CheckCircle,
    ArrowLeft
} from 'lucide-react';

const KYCView = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [status, setStatus] = useState('none'); // none, pending, verified

    const handleComplete = () => {
        setStatus('pending');
        setTimeout(() => {
            setStatus('verified');
            // Simulate backend update
            localStorage.setItem('user_verified', 'true');
        }, 3000);
    };

    return (
        <div className="kyc-view animate-fade">
            <div className="kyc-header">
                <button className="back-btn" onClick={() => navigate(-1)}><ArrowLeft size={20} /></button>
                <h2>Verify Identity</h2>
            </div>

            {status === 'none' && (
                <div className="kyc-content card">
                    <div className="status-banner info">
                        <ShieldCheck size={20} />
                        <p>Verification unlocks premium services like Housekeeping & Airport Security detail.</p>
                    </div>

                    <div className="kyc-steps">
                        <div className={`k-step ${step >= 1 ? 'active' : ''}`}>
                            <div className="num">1</div>
                            <div className="txt">
                                <h4>Document ID</h4>
                                <p>Upload Passport or Driver's License</p>
                            </div>
                        </div>
                        <div className={`k-step ${step >= 2 ? 'active' : ''}`}>
                            <div className="num">2</div>
                            <div className="txt">
                                <h4>Live Selfie</h4>
                                <p>Take a real-time photo</p>
                            </div>
                        </div>
                    </div>

                    <div className="upload-area">
                        {step === 1 ? (
                            <div className="upload-box" onClick={() => setStep(2)}>
                                <Upload size={32} color="var(--primary-green)" />
                                <p>Upload ID Document</p>
                                <span>Mocks auto-processing...</span>
                            </div>
                        ) : (
                            <div className="upload-box" onClick={handleComplete}>
                                <Camera size={32} color="var(--primary-green)" />
                                <p>Capture Selfie</p>
                                <span>Position your face clearly</span>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {status === 'pending' && (
                <div className="status-view animate-fade">
                    <div className="pulse-icon">📂</div>
                    <h3>Reviewing Documents</h3>
                    <p>Our safety team is verifying your identity. This usually takes 2–5 minutes.</p>
                    <button className="secondary-btn full-w" onClick={() => navigate('/')}>Back to Home</button>
                </div>
            )}

            {status === 'verified' && (
                <div className="status-view animate-fade">
                    <div className="success-icon-big"><CheckCircle size={60} color="var(--primary-green)" /></div>
                    <h3>Identity Verified!</h3>
                    <p>You now have full access to all EZ Naija verified providers and premium transport.</p>
                    <div className="gold-badge-display">
                        <span className="badge-verified">EZ Verified</span>
                    </div>
                    <button className="primary-btn full-w" onClick={() => navigate('/')}>Continue</button>
                </div>
            )}

            <style dangerouslySetInnerHTML={{
                __html: `
        .kyc-view { padding: 20px; }
        .kyc-header { display: flex; align-items: center; gap: 16px; margin-bottom: 30px; }
        .kyc-header h2 { font-size: 20px; margin: 0; }
        .back-btn { background: none; color: var(--text-dark); padding: 0; }
        
        .status-banner { display: flex; gap: 12px; padding: 12px; border-radius: 8px; margin-bottom: 24px; font-size: 13px; line-height: 1.4; }
        .status-banner.info { background: var(--light-green); color: var(--primary-green); }
        
        .kyc-steps { display: flex; flex-direction: column; gap: 16px; margin-bottom: 30px; }
        .k-step { display: flex; gap: 16px; opacity: 0.5; transition: 0.3s; }
        .k-step.active { opacity: 1; }
        .k-step .num { width: 28px; height: 28px; border-radius: 50%; border: 2px solid var(--primary-green); display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 800; color: var(--primary-green); }
        .k-step h4 { font-size: 15px; margin: 0; }
        .k-step p { font-size: 12px; color: var(--text-light); margin: 0; }
        
        .upload-area { margin-top: 40px; }
        .upload-box { height: 200px; border: 2px dashed var(--border-gray); border-radius: var(--radius-lg); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; cursor: pointer; }
        .upload-box p { font-weight: 700; color: var(--text-dark); margin: 0; }
        .upload-box span { font-size: 11px; color: var(--text-light); }
        
        .status-view { text-align: center; padding: 60px 20px; }
        .pulse-icon { font-size: 60px; margin-bottom: 24px; animation: pulse 2s infinite; }
        @keyframes pulse { 0% { opacity: 1; transform: scale(1); } 50% { opacity: 0.6; transform: scale(1.1); } 100% { opacity: 1; transform: scale(1); } }
        
        .success-icon-big { margin-bottom: 24px; }
        .gold-badge-display { margin: 20px 0 40px; }
        .full-w { width: 100%; }
      `}} />
        </div>
    );
};

export default KYCView;
